import React from "react";
import Navigation from "../../components/navigation";
import Footer from "../../components/footer";
import ResponsiveMenu from "../../components/responsive-navigation";
import HelmetComponent from "../../components/helmet";
import UserService from "../../services/user";

const STATE = {
    CONFIRM: "CONFIRM",
    SUBMITTING: "SUBMITTING",
    DONE: "DONE",
    INVALID: "INVALID",
    ERROR: "ERROR"
};

class Unsubscribe extends React.Component {

    constructor(props) {
        super(props);

        const params = new URLSearchParams(this.props.location.search);
        this.userSub = params.get('u');
        this.token = params.get('t');

        this.state = {
            status: (this.userSub && this.token) ? STATE.CONFIRM : STATE.INVALID
        };
    }

    async unsubscribe() {
        this.setState({status: STATE.SUBMITTING});

        try {
            await UserService.unsubscribeFromMessageEmails(this.userSub, this.token);
            this.setState({status: STATE.DONE});
        } catch (error) {
            const statusCode = error?.response?.status;
            this.setState({status: (statusCode === 400 || statusCode === 404) ? STATE.INVALID : STATE.ERROR});
        }
    }

    renderNavigation() {
        return <Navigation navigation={this.props.navigation}/>
    }

    renderFooter() {
        return <Footer/>
    }

    renderRenderResponsiveMenu() {
        return <ResponsiveMenu navigation={this.props.navigation}/>
    }

    renderBody() {
        switch (this.state.status) {
            case STATE.DONE:
                return <div>
                    <h3>You've been unsubscribed</h3>
                    <p>You will no longer receive an email when someone sends you a message on OpenSwap.</p>
                    <p>You'll still see new messages in your inbox whenever you visit OpenSwap.</p>
                    <p><a href="/chat">Go to my messages</a></p>
                </div>;
            case STATE.INVALID:
                return <div>
                    <h3>This unsubscribe link isn't valid</h3>
                    <p>The link may be incomplete or out of date. Please open the most recent notification
                        email and use the unsubscribe link at the bottom of it.</p>
                    <p>If you keep seeing this, contact <a href="mailto:info@openswap.io">info@openswap.io</a>.</p>
                </div>;
            case STATE.ERROR:
                return <div>
                    <h3>Something went wrong</h3>
                    <p>We couldn't update your email preferences just now. Please try again in a moment.</p>
                    <p>
                        <button className="site-btn" onClick={() => this.unsubscribe()}>Try again</button>
                    </p>
                </div>;
            case STATE.SUBMITTING:
                return <div>
                    <h3>Unsubscribing…</h3>
                    <p>One moment please.</p>
                </div>;
            default:
                return <div>
                    <h3>Unsubscribe from message emails</h3>
                    <p>Stop receiving an email every time someone sends you a message on OpenSwap?</p>
                    <p>This only affects message notification emails. Account and purchase emails will
                        still be sent.</p>
                    <p>
                        <button className="site-btn" onClick={() => this.unsubscribe()}>Unsubscribe</button>
                    </p>
                </div>;
        }
    }

    renderContent() {
        return <div>
            <header>
                <div className="nav-container">
                    <div className="container">
                        {this.renderNavigation()}
                    </div>
                </div>
            </header>
            <section>
                <div className="container top-padding">
                    {this.renderBody()}
                </div>
            </section>
            {this.renderFooter()}
            {this.renderRenderResponsiveMenu()}
            <HelmetComponent title='Unsubscribe' description='Manage your OpenSwap email notifications.'/>
        </div>
    }

    render() {
        return this.renderContent();
    }
}

export default Unsubscribe;
